import Vue from "vue"
import VueRouter from "vue-router"
import discountZone from "./modules/discountZone"
import downloadApp from "./modules/downloadApp"
import purchaseRecommend from "./modules/purchaseRecommend"
import unbound from "./modules/unbound"
import boundGeneral from "./modules/boundGeneral"
import businessStaff from "./modules/businessStaff"
import feedBack from "./modules/feedBack"
import serviceMarket from "./modules/serviceMarket"
import userServiceAgreement from "./modules/userServiceAgreement" //智慧脸用户服务协议
import userPrivacyPolicy from "./modules/userPrivacyPolicy" //智慧脸隐私政策
import legalStatement from "./modules/legalStatement" //法律声明
import robot from "./modules/robot" //小智机器人
import robotAnalysis from "./modules/robotAnalysis" //小智机器人-效果分析
Vue.use(VueRouter)

const routes = [
  discountZone,
  downloadApp,
  purchaseRecommend,
  unbound,
  boundGeneral,
  businessStaff,
  feedBack,
  serviceMarket,
  userServiceAgreement,
  userPrivacyPolicy,
  legalStatement,
  robot,
  robotAnalysis,
  {
    name: "login",
    path: "/login",
    component: () => import("@/views/login/index.vue")
  },
  {
    name: 'logistics',
    path: '/logistics',
    component: () => import('@/views/logistics/index.vue')
  },
  {
    name: 'materialDownload',
    path: '/materialDownload',
    component: () => import('@/views/robot/materialDownload.vue')
  }
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
